<template>
  <div class="content">
    <div class="centermodel">
      <div class="top344">
        <div class="shopInfo">
          <span class="shopMingzi">{{ shopName }}</span>
          <div shopjieshao>
            <span v-if="shopIntroduce" class="shopProduct">{{
              shopIntroduce
            }}</span>
            <span style="font-size: 16px; margin-top: 20px" v-else
              >该企业未填写店铺简介哦~</span
            >
          </div>
        </div>
        <div class="renzhengInfo">
          <div class="shopQiye">
            <img
              class="qiye"
              src="../../assets/images/qiyerenzheng.png"
              alt=""
            />
            <div class="qiyelable">企业真实性已检验</div>
          </div>
          <div class="shopApply">
            <img
              class="apply"
              src="../../assets/images/shenqinrenhzeng.png"
              alt=""
            />
            <div class="applyLable">申请人身份已检验</div>
          </div>
        </div>
      </div>
      <!-- <div class="center">{{ shopName }}</div>
      <div class="bottom">{{ shopName }}</div> -->
      <div class="extBox">
        <div class="entTitle">企业工商信息</div>
        <div v-if="formData">
          <span></span>
          <p style="font-size: 16px; color: #f77b0b; text-align: center">
            前往“全国工商局查询系统”核实信息>
          </p>
          <table class="entTable" style="width: 100%">
            <tr>
              <th>公司名称:</th>
             <td v-if="formData.enterpriseName || formData.otherName || formData.subjectName">
                {{ formData.enterpriseName || formData.otherName || formData.subjectName }}
              </td>
              <td v-else>暂无</td>
              <th>企业类型:</th>
              <td v-if="formData.authenType == 2">个体经营户</td>
              <td v-else-if="formData.authenType == 3">企业用户</td>
              <td v-else-if="formData.authenType == 4">事业单位或社会团体</td>
              <td v-else>暂无</td>
            </tr>
            <tr>
              <th>统社会信用代码:</th>
              <td v-if="formData.enterpriseCode || formData.otherCode || formData.subjectCode">
                {{ formData.enterpriseCode || formData.otherCode || formData.subjectCode }}
              </td>
              <td v-else>暂无</td>
              <th>法定代表人:</th>
              <td v-if="formData.enterpriseOperator">
                {{ formData.enterpriseOperator }}
              </td>
              <td v-else>暂无</td>
            </tr>
            <tr>
              <!-- <th>注册资本:</th>
              <td></td> -->
              <th>成立日期:</th>
              <td colspan="3" v-if="formData.enterpriseStartTime || formData.otherStartTime || formData.subjectStartTime">
                {{ formData.enterpriseStartTime || formData.otherStartTime || formData.subjectStartTime }}
              </td>
              <td v-else>暂无</td>
            </tr>
            <tr>
              <th>注册地址:</th>
              <td colspan="3" v-if="formData.enterpriseRegion || formData.otherRegion || formData.subjectRegion">
                <span  v-if="formData.enterpriseRegion || formData.otherRegion || formData.subjectRegion">
                  {{ formData.enterpriseRegion || formData.otherRegion || formData.subjectRegion}}
                </span>
                <span v-if="formData.enterpriseAdress || formData.otherAdress || formData.subjectAdress">

                </span>
                {{  formData.enterpriseAdress || formData.otherAdress || formData.subjectAdress}}
              </td>
              <td v-else>暂无</td>
            </tr>
            <!-- <tr>
              <th>企业状态:</th>
              <td>经营中</td>
              <th>登记机关:</th>
              <td></td>
            </tr> -->

            <!-- <tr>
              <th>经营范围:</th>
              <td colspan="3">
                
              </td>
            </tr> -->
          </table>
        </div>
        <div class="extBox">
          <div class="entTitle">企业资质证书</div>
          <div>
            <swiper class="swiper" :options="swiperOption">
              <swiper-slide
                class="swiper-slide"
                v-for="item in imgList"
                :key="item"
              >
                <div class="swiper-content">
                  <img :src="item" alt="" />
                </div>
              </swiper-slide>
              <!-- <div class="swiper-pagination" slot="pagination"></div>
              <div class="swiper-button-prev" slot="button-prev">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div class="swiper-button-next" slot="button-next">
                <i class="el-icon-arrow-right"></i>
              </div> -->
            </swiper>
          </div>
          <!-- <div v-else style="margin-left: 740px;">暂无资质证书~</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api";
import { listSearchMixin } from "../../config/mixin";
import { mapGetters, mapMutations } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  mixins: [listSearchMixin],
  data() {
    return {
      imgList: [],
      // 轮播图
      swiperOption: {
        slidesPerView: 5, // 每页展示几条数据
        slidesPerGroup: 1, // 每屏滚动几条数据
        autoplay: false, // 是否自动播放
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "",
        },
        observer: true,
        observeParents: true,
      },
      formData: {},
      index: "1",
      classifyTitle: "",
      shopClassifyList: [],
      shopId: null,
      productList: [],
      shopName: null,
      shopLogo: null,
      total: 0,
      type: "",
      volume: "",
      page: 1,
      pageSize: 12,
      item: [],
      maxMoney: "",
      minMoney: "",
      shopIntroduce: "",
      keyword: "",
      setCollectData: "",
      id:"",
    };
  },
  computed: {
    ...mapGetters(["collectData"]),
    // ...mapMutations({
    //   setSearchObj: "SET_SEARCHOBJ",
    // }),
    
  },
  mounted() {
    this.shopId = parseInt(this.$route.query.shopId);
    this.getShopInfo();
    this.getEnterpriseInfo();
  },
  methods: {
    getEnterpriseInfo() {
      //获取店铺企业信息
      let params = {
        url: api.getShopEntInfo +`?shopId=${this.shopId}`,
        method: "get",

      };
      let _this = this
      _this.sendReq(params, (res) => {
        if (res.data && Object.keys(res.data.enterprise).length > 0 ) {
          this.formData = res.data.enterprise;
          this.formData.authenType = res.data.authenType
          this.imgList.push(this.formData.enterpriseLicense);
          this.swiperOption.slidesPerView = this.imgList.length;
        }else if(res.data && Object.keys(res.data.individualBusinesses).length > 0  ){
          this.formData = res.data.individualBusinesses;
          this.formData.authenType = res.data.authenType
          this.imgList.push(this.formData.subjecLicense);
          this.swiperOption.slidesPerView = this.imgList.length;
        }else if(res.data && Object.keys(res.data.otherOrganizations).length > 0  ){
          this.formData = res.data.otherOrganizations;
          this.formData.authenType = res.data.authenType
          this.imgList.push(this.formData.otherLicense);
          this.swiperOption.slidesPerView = this.imgList.length;
        }
        // if (res.code == 200) {
        //   _this.id = res.data.enterpriseId
          
        //   let form_data = new FormData();
        //   form_data.append("id", _this.id);
        //   let params2 = {
        //     url: api.getShopInfoEn,
        //     method: "POST",
        //     contentType:"application/x-www-form-urlencoded",
        //     data: form_data
        //   }
        //   _this.sendReq(params2, (res2) => {
        //     if (res2.ret == 200) {
        //       _this.formData = res2.data
        //       _this.imgList.push(_this.formData.enterpriseLicense);
        //       _this.swiperOption.slidesPerView = _this.imgList.length;
        //     }
        //   })
        // }
      });
    },

    //获取企业信息
    getShopEntInfos(){
      let params = {
        url: api.getEntInfo,
        method: "post",
        data:{
          buyerUserId:""
        }

      };
      this.sendReq(params, (res) => {
        
      });
    },

    // 获取店铺首页
    getShopInfo() {
      let params = {
        url: api.getShopIndex + `?shopId=${this.shopId}`,
        method: "GET",
      };
      this.sendReq(params, (res) => {
        if (res.code === "200") {
          // let data = {
          //   shopName: res.data.shopName,
          //   shopIntroduce: res.data.shopIntroduce,
          // };
          this.shopName = res.data.shopName;
          this.shopIntroduce = res.data.shopIntroduce;
          for (let i = 0; i < res.data.cereCertificateShop.length; i++) {
            let f = res.data.cereCertificateShop[i].imgUrl.replace('["', "");
            let g = f.replace('"]', "");
            let k = unescape(g.replace(/\\u/g, "%u"));
            this.imgList.push(k);
          }
          this.swiperOption.slidesPerView = this.imgList.length;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
  },
};
</script>
<style lang = 'scss' scoped>
.entTable {
  width: 100%;
  margin-top: 20px;
  tr {
    height: 50px;
    line-height: 50px;
    th {
      width: 200px;
      background: #f2f3f4;
      border: 1px solid #e5e5e5;
      padding: 0 20px;
      text-align: right;
    }
    td {
      padding: 0 20px;
      border: 1px solid #e5e5e5;
    }
  }
}

.swiper-content {
  padding: 0 50px 50px 50px;
}
.swiper-container {
  height: 400px;
  line-height: 400px;
  --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
  --swiper-navigation-color: #00ff33; /* 单独设置按钮颜色 */
  --swiper-navigation-size: 30px; /* 设置按钮大小 */
  img {
    width: 100%;
    margin: auto 0;
  }
}
.swiper-button-prev {
  width: 35px;
  height: 35px;
  background: #fde5ce;
  color: #f77b0b;
  font-size: 28px;
  text-align: center;
  line-height: 35px;
  border-radius: 50%;
}
.swiper-button-next {
  width: 35px;
  height: 35px;
  background: #fde5ce;
  color: #f77b0b;
  font-size: 28px;
  text-align: center;
  line-height: 35px;
  border-radius: 50%;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.content {
  background: #f6f6f6;
  margin-top: 20px;
}
.extBox {
  margin-top: 50px;
  width: 100%;
  .entTitle {
    font-size: 26px;
    width: 100%;
    text-align: center;
    font-weight: bold;
    color: #000000;
  }
}
.centermodel {
  width: 100%;
  background: white;
  padding: 30px;
}
.shopQiye {
  text-align: center;
  img {
    margin-bottom: 10px;
  }
}
.shopApply {
  text-align: center;
  img {
    margin-bottom: 10px;
  }
}
.shopMingzi {
  font-size: 24px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #333333;
  line-height: 31px;
  margin-bottom: 20px;
}
.shopjieshao {
  width: 674px;
  height: 178px;
}
.shopProduct {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #333333;
  line-height: 22px;
  letter-spacing: 1px;
}
.qiye {
  width: 108px;
  height: 121px;
}
.qiyelable {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: #000000;
  line-height: 21px;
}
.apply {
  width: 108px;
  height: 121px;
}
.shopInfo {
  /* margin-left: 62px; */
}
.shopApply {
  margin-left: 100px;
  margin-right: 40px;
}
.applyLable {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: #000000;
  line-height: 21px;
}
.renzhengInfo {
  margin-left: 80px;
}
.top344 {
  display: flex;
  /* height: 1308px; */
  padding-top: 30px;
  padding-left: 30px;
  justify-content: space-between;
}
.renzhengInfo {
  display: flex;
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/canvasShow/dossier.vue